import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Author, UserRole } from '../types';

interface AuthState {
  token: string | null;
  role: UserRole;
  user: Author | null;
  setToken: (token: string | null) => void;
  setUser: (role: UserRole, user?: Author | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      role: 'guest',
      user: null,
      setToken: (token) => {
        if (token) localStorage.setItem('token', token);
        else localStorage.removeItem('token');
        set({ token });
      },
      setUser: (role, user = null) => set({ role, user }),
      logout: () => {
        localStorage.removeItem('token');
        set({ token: null, role: 'guest', user: null });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ token: state.token, role: state.role, user: state.user }),
    },
  ),
);
